import React, { Component } from 'react';

import { Label, Headline, Button } from '../../theme';
import { Slider, Slide } from '../../carousel';
import { Fridge } from '../../svg';
import { isMobile } from '../../util';

class FridgeProblem extends Component {
  render() {
    return (
      <div id="Frigider" className="container__fluid">
        <div className="w__flex w__flex-row Justify-between w__flex-column__mobile">

          <div className="w__flex w__flex-column carousel Justify-between Align-center o-2__mobile Align-right__mobile">
            <Slider device="frigider">

              <Slide
                text="Un frigider vechi sau deteriorat consuma cu 50% mai multa energie decat unul nou iar riscul sa se strice periodic este foarte ridicat?"
              />

              <Slide
                text="Poti reduce consumul de energie al frigiderului, acoperind vasele ce contin lichide sau mancare? Acestea nu vor mai creste nivelul de umiditate si astfel, compresorul va fi mai putin solicitat"
              />

            </Slider>
            <Button enel >
              <span className="mobile__hidden">Vezi</span>  oferta enel
            </Button>
          </div>

          <div className="w__flex w__flex-column Align-right problem__content">
            {
              !isMobile && (
                <div className="plate">
                  <Fridge.Plate />
                </div>
              )
            }
            <Label marginRight="4.16vw" background="#840050" >
              problema tatalui
            </Label>
            <Headline padding="4.16vw" large alignRight >
              <p style={{ color: '#840050' }}>uit sa inchid</p>
              <p style={{ color: '#840050' }}>usa frigiderului</p>
              <p style={{ color: '#d33c64' }}>...pana vine</p>
              <p style={{ color: '#d33c64' }}>
                {
                  !isMobile && (
                    <span className="guy">
                      <Fridge.Guy />
                    </span>
                  )
                }
                factura
                </p>
            </Headline>
            {
              isMobile && (
                <span className="guy">
                  <Fridge.Guy />
                </span>
              )
            }
          </div>

        </div>
      </div>
    );
  }
}

export default FridgeProblem;


// WEBPACK FOOTER //
// ./src/components/pages/Frigider/FridgeProblem.jsx